module.exports = __webpack_public_path__ + "img/logo-light-text.7810e4db.png";